import { getLink } from '@frameio/shared/routing';

export const getProjectLink = (id: string) =>
  id ? getLink({ page: 'folder', projectId: id }).toString() : '';
